const SEV = {
  red: { label: "High", fg: "var(--red)", bg: "var(--red-bg)" },
  amber: { label: "Watch", fg: "var(--amber)", bg: "var(--amber-bg)" },
  green: { label: "OK", fg: "var(--green)", bg: "var(--green-bg)" },
};

export const SeverityBadge = ({ severity }) => {
  const s = SEV[severity] || SEV.amber;
  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 font-mono-d text-[10px] uppercase tracking-widest"
      style={{ color: s.fg, background: s.bg }} data-testid={`severity-${severity}`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.fg }} />
      {s.label}
    </span>
  );
};

export const FindingCard = ({ finding, index }) => (
  <article data-testid={`finding-card-${index}`}
    className="bg-[var(--card)] border border-[var(--rule)] p-6 md:p-7 border-l-[3px] rise"
    style={{ borderLeftColor: (SEV[finding.severity] || SEV.amber).fg, animationDelay: `${index * 60}ms` }}>
    <div className="flex items-center gap-3 mb-3">
      <SeverityBadge severity={finding.severity} />
      {finding.page && <span className="font-mono-d text-xs text-[var(--ink-3)]">p.{finding.page}</span>}
    </div>
    <h4 className="font-serif-d text-2xl leading-snug mb-4">{finding.title}</h4>
    {finding.quote && (
      <blockquote className="font-mono-d text-[13px] leading-relaxed bg-[var(--paper)] border-l-2 border-[var(--ink-3)] px-4 py-3 mb-4 text-[var(--ink-2)]">
        “{finding.quote}”
      </blockquote>
    )}
    {finding.why && <p className="text-sm text-[var(--ink-2)] mb-2 leading-relaxed"><strong className="text-[var(--ink)] font-semibold">Why it matters:</strong> {finding.why}</p>}
    {finding.action && <p className="text-sm text-[var(--ink-2)] leading-relaxed"><strong className="text-[var(--ink)] font-semibold">Suggested move:</strong> {finding.action}</p>}
  </article>
);
